<template>
  <i
    class="statistic-icon"
    :style="{
      height: pixelSize + 'px',
      width: pixelSize + 'px',
      'background-size': (pixelSize * size.x) + 'px ' + (pixelSize * size.y) + 'px',
      'background-position': (pixelSize * suite[method].x) + 'px ' + (pixelSize * suite[method].y) + 'px',
      'margin-top': '5px'
    }" />
</template>

<script>
export default {
  props: {
    method: String,
    pixelSize: {
      type: Number,
      default: 32
    }
  },
  data () {
    return {
      suite: {
        statistic: { x: 0, y: 0 }
      },
      size: {
        x: 1,
        y: 1
      }
    }
  }
}
</script>

<style scoped>
.statistic-icon { background: url(../../assets/statistics2.svg); display: inline-block; margin-right: 10px; margin-top: 1px !important; cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/icons/StatisticIcon2.vue